"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Initialization_1 = require("../Initialization");
var SearchInterfaceComponentInitializer_1 = require("../../resolvers/components/SearchInterfaceComponentInitializer");
var SitecoreExperienceEditor_1 = require("./SitecoreExperienceEditor");
var coveo_search_ui_1 = require("coveo-search-ui");
var SearchInterfaceInitializer = (function () {
    function SearchInterfaceInitializer(experienceEditor, searchInterfaceComponentInitializer) {
        if (experienceEditor === void 0) { experienceEditor = SitecoreExperienceEditor_1.getExperienceEditorInstance(); }
        if (searchInterfaceComponentInitializer === void 0) { searchInterfaceComponentInitializer = SearchInterfaceComponentInitializer_1.getInitializerInstance(); }
        this.experienceEditor = experienceEditor;
        this.searchInterfaceComponentInitializer = searchInterfaceComponentInitializer;
    }
    SearchInterfaceInitializer.prototype.initSearchInterface = function (searchInterface) {
        if (!this.experienceEditor.isInBackgroundRendering()) {
            this.experienceEditor.registerShowDebugInformationCallback();
            Initialization_1.initContextOnElement(searchInterface);
            return coveo_search_ui_1.init(searchInterface);
        }
    };
    SearchInterfaceInitializer.prototype.initializeExperienceEditorHooksForSearchInterface = function (searchInterface) {
        var _this = this;
        this.experienceEditor.registerOnLoadRenderingFromUrl(function (callbackData) {
            if (!callbackData.error) {
                var component = _this.experienceEditor.getComponentFromLoadRenderingFromUrlCallbackData(callbackData);
                // Since multiple search interfaces can register event handlers, this ensures that the component is initializing for the correct search interface.
                if (searchInterface.contains(component)) {
                    var searchInterfaceComponent = Coveo.get(searchInterface, Coveo.SearchInterface);
                    _this.searchInterfaceComponentInitializer.loadComponentsForSearchInterface(searchInterfaceComponent, component);
                }
            }
        });
    };
    return SearchInterfaceInitializer;
}());
exports.SearchInterfaceInitializer = SearchInterfaceInitializer;



//////////////////
// WEBPACK FOOTER
// ./src/base/initialization/SearchInterfaceInitializer.ts
// module id = 31
// module chunks = 13 14